export var EAgentType;
(function (EAgentType) {
  EAgentType["Builder"] = "builder";
  EAgentType["Seller"] = "seller";
})(EAgentType || (EAgentType = {}));